var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import * as React from "react";

function SvgKitchen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.2567 15.0036H34.8222V12.383C34.8222 9.44808 32.4346 7.06042 29.4997 7.06042C26.5648 7.06042 24.1771 9.44808 24.1771 12.383V15.0038H20.7427V12.383C20.7427 7.5542 24.671 3.62598 29.4997 3.62598C34.3283 3.62598 38.2567 7.5542 38.2567 12.383V15.0036Z",
    fill: "#3A4D5C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5984 27.4004H8.40245C4.70331 27.4004 1.69385 30.4099 1.69385 34.1091V51.9768H5.12818V34.1091C5.12818 32.3038 6.59707 30.8348 8.40348 30.8348H50.5971C52.4026 30.8348 53.8715 32.3036 53.8715 34.1091V51.9768H57.306V34.1091C57.306 30.4099 54.2964 27.4004 50.5984 27.4004Z",
    fill: "#3A4D5C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2545 11.292H29.4998H20.7451C19.5171 18.8931 15.4806 24.2589 10.3916 27.4558V55.3737H29.4998H48.608V27.4557C43.5187 24.2589 39.4823 18.8931 38.2545 11.292Z",
    fill: "#D0E2EE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.961 29.9738C39.961 28.5632 38.8068 27.4092 37.3962 27.4092H21.6033C20.1928 27.4092 19.0386 28.5632 19.0386 29.9738V43.2022H39.9609V29.9738H39.961Z",
    fill: "#7D8E9E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0386 43.2021V49.4116C19.0386 50.822 20.1928 51.9762 21.6033 51.9762H37.3962C38.8068 51.9762 39.961 50.822 39.961 49.4116V43.2021H19.0386Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKitchen);
export default __webpack_public_path__ + "static/media/kitchen.5632d329559f45da29f9320b6f907905.svg";
export { ForwardRef as ReactComponent };